import { z } from 'zod';

export const LoqateFindRequestSchema = z.object({
  Key: z.string(),
  Text: z.string(),
  Container: z.string().optional(),
  IsMiddleware: z.boolean(),
  Origin: z.string().default(''),
  Countries: z.literal('CA'),
  Limit: z.string().default('7'),
  Bias: z.boolean(),
  Language: z.string(),
});

export const AddressAutocompleteSchema = z.object({
  Description: z.string(),
  Highlight: z.string(),
  Id: z.string(),
  Text: z.string(),
  Type: z.string(),
});

export const LoqateFindResponseSchema = z.object({
  Items: z.array(AddressAutocompleteSchema),
});
